export default {
  buttons: {
    continue: "Continue",
    back: "Back",
    backToPaths: "Course Overview",
    replayPath: "Start Course",
    backToJourney: "Back To Course",
    viewFullLesson: "View Full Course",
    buy: "Buy",
    analyzeJourney: "Analyze Course",
    regenerateAnalysis: "Regenerate Analysis",
    showJourneyAnalysis: "Show Course Analysis",
    downloadPdf: "Download PDF",
  },
  messages: {
    finish: "You've successfully completed the course:",
    stepLocked: "This step is locked.",
    initiated: "You've used up {credits} credits",
    generateAnalysisFirst: "Please generate an analysis first.",
  },
  notifications: {
    generatingAnalysis: "Generating course analysis. You will be notified once the analysis is complete.",
    analysisReady: "Course analysis is ready!",
  },
  titles: {
    learningPath: "Course",
    finish: "Congratulations!",
    analysis: "Your Course Analysis",
    keyTakeaways: "Key Takeaways",
    strengths: "Strengths",
    weaknesses: "Areas for Improvement",
    completionOverview: "Completion Overview",
    exerciseCompletion: "Exercise Completion",
    exercises: "Exercises",
    noLessonAnalysisFound: "No course analysis found",
    exerciseDescription: "Exercise Description",
  },
  gameHistoryList: {
    name: "Name",
    type: "Type",
    startedAt: "Started At",
    endedAt: "Ended At",
    status: "Status",
    userInfo: "User Info",
    userName: "Name",
    lessonCompletion: "Course Completion",
  },
};
